import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {
    const { auditAssetId } = action.payload;
    const url = `${config.api.paths.validatedAuditAsset}?audit_asset_id=${auditAssetId}`;
    try {
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data.assetAuditors));
    } catch (error) {
        logToSentry("On validated visibility assets get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(
            actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_REQUEST,
            getRequest
        )
    ]);
}
